import { z } from 'zod';

/** 仕様設定タブで設定対象を切り替えるサブヘッダーの値。 */
export const PAYROLL_CORE_CONFIG_KINDS = ['operationEvents', 'operationPackages'] as const;
export type PayrollCoreConfigKind = (typeof PAYROLL_CORE_CONFIG_KINDS)[number];
export const SearchSchema = z.object({
  kind: z.enum(PAYROLL_CORE_CONFIG_KINDS).default('operationEvents')
});